export const workFlowItem = [
  {
    value: "Move Out",
  },
  {
    value: "Make Ready",
  },
  {
    value: "SD Refund",
  },
  {
    value: "Property Listing",
  },
  {
    value: "Listing Follow up",
  },
  {
    value: "Move In",
  },
  {
    value: "Work Order Follow Up",
  },
  {
    value: "Lease Renewal",
  },
  {
    value: "Pay / Quit",
  },
];

export const data = [
  {
    title: "A. Move Out",
    description: "Tenant move out process",
    emoji: "🚚",
  },
  {
    title: "B. Make Ready",
    description: "",
    emoji: "🛠️",
  },
  {
    title: "C. SD Refund",
    description: "",
    emoji: "💸",
  },
  {
    title: "D. Property Listing",
    description: "",
    emoji: "🏡",
  },
  {
    title: "E. Listing Follow up",
    description: "",
    emoji: "✒️",
  },
  {
    title: "F. Move In",
    description: "",
    emoji: "📋",
  },
  {
    title: "G. Work Order Follow up",
    description: "",
    emoji: "👷‍♀️",
  },
  {
    title: "H. Lease Renewal",
    description: "",
    emoji: "🏘️",
  },
  {
    title: "I. Pay / Quit",
    description: "these are the steps to follow each month to send out ",
    emoji: "👨‍⚖️",
  },
];
